/**
 * Snake Snacks shopping analytics (custom events).
 *
 * Shopify already records page, product, collection, search, cart and checkout events on its own.
 * This file adds the shopping-path events from the redesign report on top, published with
 * Shopify.analytics.publish so a Customer Events pixel can forward them (docs/analytics-custom-pixel.js):
 *   snake_category_select   tapped a category (level 1 / 2 / 3)
 *   snake_select_item       opened a product, and from which list (shelf, category, search…)
 *   snake_promotion_select  tapped a homepage promo card
 *   snake_filter_update     changed filters / sort on a category or search page
 *   snake_search            search results page viewed, with result count (zero-result rate)
 *   snake_search_suggest    live suggestions shown, with result count
 * Nothing here collects personal data.
 */
const publish = (name, data) => {
  try {
    window.Shopify?.analytics?.publish?.(name, { ...data, page: location.pathname });
  } catch (e) {
    /* analytics must never break shopping */
  }
};

const text = (el) => (el?.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);

document.addEventListener(
  'click',
  (event) => {
    const target = /** @type {HTMLElement} */ (event.target);

    const productLink = target.closest('.snc__link');
    if (productLink) {
      const card = /** @type {HTMLElement} */ (productLink.closest('[data-snc]'));
      const list = /** @type {HTMLElement | null} */ (card?.closest('[data-list-name]'));
      const cards = list ? Array.from(list.querySelectorAll('[data-snc]:not([hidden])')) : [];
      publish('snake_select_item', {
        product_id: card?.dataset.id,
        product_title: card?.dataset.title,
        brand: card?.dataset.vendor,
        list: list?.dataset.listName || 'Other',
        position: cards.indexOf(card) + 1,
      });
      return;
    }

    const promo = target.closest('.snk-promo');
    if (promo) {
      const all = Array.from(document.querySelectorAll('.snk-promo'));
      publish('snake_promotion_select', {
        promotion: text(promo.querySelector('.snk-promo__title')),
        position: all.indexOf(promo) + 1,
      });
      return;
    }

    const category = target.closest(
      '.snk-l1, .snk-l2__item, .snk-cats__tile, .snk-cats__hero, .snk-tree__link, [data-type-chip], .snk-hd__nav-list a, .snk-ps__chips a'
    );
    if (category) {
      const level = category.matches('[data-type-chip], [data-type-link]')
        ? 3
        : category.matches('.snk-l1, .snk-cats__hero, .snk-hd__nav-list a') || category.closest('.snk-tree__l1 > .snk-tree__row')
          ? 1
          : 2;
      publish('snake_category_select', {
        category:
          category.dataset.category ||
          text(category.querySelector('.snk-l2__label, .snk-cats__name') || category).replace(/\s\d+$/, ''),
        level,
        source: category.closest('.snk-cats') ? 'categories screen' : category.closest('.snk-tree') ? 'sidebar' : category.closest('.snk-search__panel') ? 'search suggestions' : category.closest('.snk-hd') ? 'header' : 'page',
      });
    }
  },
  { capture: true }
);

let filterTimer = 0;
document.addEventListener('snake:collection-update', (event) => {
  const detail = /** @type {CustomEvent} */ (event).detail || {};
  clearTimeout(filterTimer);
  // wait until the shopper settles, and skip the initial render
  filterTimer = window.setTimeout(() => {
    if (!detail.type && detail.sort === (document.querySelector('[data-search-terms]') ? 'relevance' : 'featured') && !Object.values(detail.filters || {}).some((v) => v.length)) return;
    publish('snake_filter_update', detail);
  }, 800);
});

document.addEventListener('snake:search-suggest', (event) => {
  publish('snake_search_suggest', /** @type {CustomEvent} */ (event).detail || {});
});

const searchPage = /** @type {HTMLElement | null} */ (document.querySelector('[data-search-count]'));
if (searchPage) {
  publish('snake_search', {
    query: searchPage.dataset.searchTerms || '',
    results: Number(searchPage.dataset.searchCount) || 0,
  });
}
